import { render, staticRenderFns } from "./spotQuestionCountPie.vue?vue&type=template&id=2010bf94&"
import script from "./spotQuestionCountPie.vue?vue&type=script&lang=js&"
export * from "./spotQuestionCountPie.vue?vue&type=script&lang=js&"
import style0 from "./spotQuestionCountPie.vue?vue&type=style&index=0&id=2010bf94&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports